export const DownArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
    <path
      d="M13.3429 10.2L7.17143 16.2M7.17143 16.2L1 10.2M7.17143 16.2L7.17143 1.79999"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
